/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import moment from 'moment';
import {
  Tag, Space, Button, Popconfirm, Dropdown,
} from 'antd';
import Can from '../../util/can';
import { MERCHANT_DETAILS, REVERSE_CURRENCY_TRANSACTION, USERS } from '../../constants/resources';
import { maskApiKey } from "../../constants/System";

export const APIColumns = (handleEdit, handleDelete) => [
  {
    title: 'Key (Masked)',
    dataIndex: 'api_key',
    render: (apiKey) => (maskApiKey(apiKey)),
    width: 150,
    fixed: 'left',
    render: (api_key, record) => (
      <span>
        {maskApiKey(api_key)}
        {' '}
        <br />
        {
          record.traffic_types.map((trafficType) => (
            <Tag color="geekblue" key={trafficType}>
              {trafficType}
            </Tag>
          ))
        }
      </span>
    ),
  },
  {
    title: 'IP Whitelist',
    dataIndex: 'ip_whitelist',
    render: (ip_whitelist) => (
      ip_whitelist
        ? ip_whitelist.map((ipAddress) => (
          <Tag color="green" key={ipAddress}>
            {ipAddress}
          </Tag>
        )) : null
    ),
    width: 200,
  },
  {
    title: 'Webhook Hash',
    dataIndex: 'webhook_hash',
    width: 150,
  },
  {
    title: 'Webhook URL',
    dataIndex: 'webhook_url',
    width: 400,
  },
  {
    title: '',
    key: 'action',
    search: false,
    fixed: 'right',
    width: 100,
    render: (record) => (
      <Space size="middle">
        <Can I="update" a={MERCHANT_DETAILS}>
          <Button
            data-testid={`update-record-${record._id}`}
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleEdit(record)}
          >
            <i className="icon icon-edit" />
          </Button>
        </Can>
        <Can I="delete" a={MERCHANT_DETAILS}>
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
            <Button
              data-testid={`delete-record-${record._id}`}
              danger
              className="ant-btn-sm ant-btn-background-ghost"
            >
              <i className="icon icon-trash" />
            </Button>
          </Popconfirm>
        </Can>
      </Space>
    ),
  },
];

export const walletColumns = (
  loadingWalletsAggregatedRollingReserve,
  walletOverview,
  transactionSummary,
  showSettlementReportCreate,
  tplusxPeriod,
) => [
    {
      title: 'CUR',
      dataIndex: 'code'
    },
    // {
    //   title: 'Commission Supported',
    //   dataIndex: 'commission',
    //   render: (value) => (
    //     <Tag color={value ? 'green' : 'red'}>
    //       {value ? 'Yes' : 'No'}
    //     </Tag>
    //   ),
    // },
    {
      title: `Collections (B4 T+${tplusxPeriod})`,
      dataIndex: '',
      render: (value) => (
        <>
          <div>
            {new Intl.NumberFormat().format(value.total)}

            <br />

            <small>
              {moment(value.period_months_ago, "YYYY-MM-DD").fromNow()}
              <br />
              {moment(value.period_months_ago).format("YYYY-MM-DD")}
            </small>
          </div>
        </>
      ),
    },
    {
      title: `Rolling Reseve`,
      dataIndex: '',
      render: (value) => (
        <Space size="middle">
          <div>
            {loadingWalletsAggregatedRollingReserve
              && 'loading...'}
            {!loadingWalletsAggregatedRollingReserve
              && new Intl.NumberFormat().format(value.totalReserve)}
            <br />
            <small>
              {`(B4 T+${tplusxPeriod})`} ~ {value.reserve}
            </small>
            <br />
            <small>
              {`(T+${tplusxPeriod})`} ~ {value.tplusxReserve}
            </small>
          </div>
        </Space>
      ),
    },
    {
      title: `Total (T+${tplusxPeriod})`,
      dataIndex: '',
      render: (value) => (
        <Space size="middle">
          <>
            <div>
              {loadingWalletsAggregatedRollingReserve
                && 'loading...'}
              {!loadingWalletsAggregatedRollingReserve
                && new Intl.NumberFormat().format(value.tplusx)}

              <br />

              <small>
                {moment(value.period_days_ago, "YYYY-MM-DD").fromNow()}
                <br />
                {moment(value.period_days_ago).format("YYYY-MM-DD")}
              </small>
            </div>
          </>
        </Space>
      ),
    },
    {
      title: 'Available Balance',
      dataIndex: '',
      render: (value) => (
        <Space size="middle">
          <span>
            {loadingWalletsAggregatedRollingReserve
              && 'loading...'}
            {!loadingWalletsAggregatedRollingReserve
              && new Intl.NumberFormat().format(value.available)}
          </span>
        </Space>
      ),
    },
    {
      title: '',
      dataIndex: '',
      key: 'action',
      render: (record) => {
        const menuItems = [
          // {
          //   key: 'overview',
          //   label: 'Overview',
          //   onClick: (e) => {
          //     if (e.key === 'overview') {
          //       walletOverview(record);
          //     }
          //   },
          // },
          // {
          //   key: 'reconcile',
          //   label: 'Reconcile',
          //   onClick: (e) => {
          //     if (e.key === 'reconcile') {
          //       transactionSummary(record);
          //     }
          //   },
          // },
          {
            key: 'settlement-report-create',
            label: 'Settlement Report - Create',
            onClick: (e) => {
              if (e.key === 'settlement-report-create') {
                showSettlementReportCreate(record);
              }
            },
          },
        ];

        return (
          <div className="gx-d-flex justify-content-center">
            <Dropdown menu={{ items: menuItems }} placement="bottomRight" trigger={['click']}>
              <i className="gx-icon-btn icon icon-ellipse-v" />
            </Dropdown>
          </div>
        );
      },
    },
  ];

export const walletTransactionsSearchFields = [
  'transaction_status', 'transaction_description',
  'transaction_type', 'kitegateway_reference', 'merchant_reference',
  'child_business_name', 'ledger_side',
];

export const transactionColumns = (
  timezone,
) => [
    {
      title: 'ID',
      dataIndex: '_id',
      sorter: true,
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      render: (date) => (
        <span>
          {moment(date).utc().add('hours', timezone.offset).format('DD/MM/YYYY h:mm:ss a')}
        </span>
      ),
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'transaction_status',
      sorter: true,
      filter: true,
      render: (transactionStatus) => {
        let color = 'default';
        if (transactionStatus === 'COMPLETED' || transactionStatus === 'COMPLETE') {
          color = 'success';
        } else if (transactionStatus === 'FAILED') {
          color = 'error';
        } else if (transactionStatus === 'CONFIRMING') {
          color = 'processing';
        } else if (transactionStatus === 'PENDING') {
          color = 'processing';
        } else if (transactionStatus === 'CANCELLED' || transactionStatus === 'CANCELLED') {
          color = 'warning';
        }

        return (
          <span className="ant-badge ant-badge-status ant-badge-not-a-wrapper">
            <span className={`ant-badge-status-dot ant-badge-status-${color}`} />
            <span className="ant-badge-status-text">{transactionStatus}</span>
          </span>
        );
      },
    },
    {
      title: 'Institution',
      dataIndex: 'institution_name',
      sorter: true,
    },
    {
      title: 'Narration',
      dataIndex: 'narration',
      sorter: true,
    },
    {
      title: 'Provider',
      dataIndex: 'provider',
      sorter: true,
    },
    {
      title: 'Request Amount',
      dataIndex: 'request_amount',
      sorter: true,
    },
    {
      title: 'Request Currency',
      dataIndex: 'request_currency',
      sorter: true,
    },
  ];

export const MerchantUserColumns = (removeUser) => [
  {
    title: 'name',
    dataIndex: 'full_name',
    sorter: true,
  },
  {
    title: 'email',
    dataIndex: 'email',
    sorter: true,
  },
  {
    title: '',
    key: 'operation',
    fixed: 'right',
    width: 60,
    render: (record) => (
      <Space size="middle">
        <Can I="delete" a={USERS}>
          <Button
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => removeUser(record)}
          >
            <i className="icon icon-trash" />
          </Button>
        </Can>
      </Space>
    ),
  },
];
